// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__EHeSb","inner":"Footer_inner__2lLfL","nextIcon":"Footer_nextIcon__2rXqJ","innerLeft":"Footer_innerLeft__9wZUz"};